var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSkipRightCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1667 12.1667V23.8334C10.1667 24.5494 11.01 24.932 11.5488 24.4606L18.2155 18.6272C18.4047 18.4617 18.4996 18.2319 18.5001 18.0019V23.8334C18.5001 24.5494 19.3433 24.932 19.8822 24.4606L26.5488 18.6272C26.9283 18.2952 26.9283 17.7049 26.5488 17.3729L19.8822 11.5396C19.3433 11.0681 18.5001 11.4508 18.5001 12.1667V17.9982C18.4996 17.7683 18.4047 17.5385 18.2155 17.3729L11.5488 11.5396C11.01 11.0681 10.1667 11.4508 10.1667 12.1667ZM16.4013 18L11.8334 21.9969V14.0032L16.4013 18ZM20.1667 14.0032L24.7346 18L20.1667 21.9969V14.0032Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSkipRightCircle);
export default __webpack_public_path__ + "static/media/icon_skip_right_circle.4fd2f2e1.svg";
export { ForwardRef as ReactComponent };